import React from 'react';
import eylemPlani from '../assets/eylemPlani.pdf';
import '../style/EylemPlaniViewer.css';

const EylemPlaniViewer = () => {
  return (
    <div className="eylem-plani-container">
      <div className="eylem-plani-header">
        <h1>Proje Çevre Eğitimi Eylem Planı (2025-2026)</h1>
        <p>
          "Dünyamızın Kaderi Ellerimizde" projemiz kapsamında hazırlanan çevre eğitimi eylem planımızı aşağıda inceleyebilirsiniz. 
          Bu plan, sürdürülebilirlik ve çevre bilinci konularında okulumuzda kalıcı davranış değişiklikleri oluşturmayı hedefler.
        </p>
        <a href={eylemPlani} download="Zekai_Gumusdis_Ortaokulu_Eylem_Plani.pdf" className="download-button">
          Eylem Planını İndir
        </a>
      </div>
      <div className="pdf-viewer">
        <object
          data={eylemPlani}
          type="application/pdf"
          width="100%"
          height="100%"
          aria-label="Eylem Planı PDF"
        >
          <p>
            Tarayıcınız PDF'leri görüntüleyemiyor.{" "}
            <a href={eylemPlani} download="Zekai_Gumusdis_Ortaokulu_Eylem_Plani.pdf">
              Eylem Planını indirmek için buraya tıklayın.
            </a>
          </p>
        </object>
      </div>
    </div>
  );
};

export default EylemPlaniViewer;